import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
//slices
import { companySelector } from 'slices/company';
// api
import { createAffiliate } from 'api/company';
// components
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import FeedbackStatus from 'components/userzone/FeedbackStatus';
//styles
import './affiliate.scss';

const resetValues = {
  name: '',
  address: '',
  phone: '',
  email: '',
  request_description: '',
  status: ''
}

const Affiliate = () => {
  const { t } = useTranslation(['home', 'backoffice', 'contact', 'card']);
  const [requestStatus, setRequestStatus] = useState('');
  const [msg, setMsg] = useState('');
  const [showCard, setShowCard] = useState(false);

  const title = t('affiliate');

  const { descripcion_pub, email: correo, telefono } = useSelector(companySelector);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: resetValues,
  });

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    goUp();
  }, []);

  const onSubmit = async (values) => {
    const payload = {
      name: values?.name,
      address: values?.address,
      phone: values?.phone,
      email: values?.email,
      request_description: values?.request_description,
      status: values?.status
    };
    try {
      const response = await createAffiliate(payload);
      if (response?.status === 201) {
        setRequestStatus('success');
        setShowCard(true);
        setMsg(t('successHome', { ns: 'home' }));
        reset(resetValues);
      } else {
        setRequestStatus('error');
        setShowCard(true);
        reset(resetValues);
        setMsg(t('somethingwrong', { ns: 'card' }))
      }
    } catch (error) {
      setRequestStatus('error');

      setTimeout(() => {
        setShowCard(false);
      }, 5000);
    }

  };

  const handleClose = () => {
    setShowCard(false);
  }

  return (
    <div className="content mr-3">
      <div className="justify-content-center d-flex mainDiv container-fluid contact">
        <Head description={descripcion_pub} title={title} noIndex={true} />
        <Row className="libraries-row justify-content-center">
          <Col lg={8} xl={9}>
            <TitleWithLine text={t('joinLibelist', { ns: 'home' })} />
            <Form onSubmit={handleSubmit(onSubmit)} className="form-affiliate">
              <Row>
                <Col md={6}>
                  <Form.Group controlId="formEmail">
                    <Form.Label className="text-dark label-form">
                      {t('name', { ns: 'backoffice' })}
                    </Form.Label>
                    <Controller
                      name="name"
                      control={control}
                      rules={{ required: { value: true, message: t('fieldrequired', { ns: 'contact' }) } }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          placeholder={t('name', { ns: 'backoffice' })}
                        />
                      )}
                    />
                    {errors.name && <small className="text-danger">{errors.name.message}</small>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formEnterprise" className="mt-xs-2">
                    <Form.Label className="text-dark">
                      {t('direccion', { ns: 'backoffice' })}
                    </Form.Label>
                    <Controller
                      name="address"
                      control={control}
                      rules={{ required: { value: true, message: t('fieldrequired', { ns: 'contact' }) } }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          placeholder={t('direccion', { ns: 'backoffice' })}
                        />
                      )}
                    />
                    {errors.address && <small className="text-danger">{errors.address.message}</small>}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="formEnterprise" className="mt-3">
                    <Form.Label className="text-dark label-form">
                      {t('telefono', { ns: 'backoffice' })}
                    </Form.Label>
                    <Controller
                      name="phone"
                      control={control}
                      rules={{
                        required: { value: true, message: t('fieldrequired', { ns: 'contact' }) },
                        pattern: {
                          value: /^[0-9]+$/,
                          message: t('solonumeros', { ns: 'backoffice' }),
                        },
                        minLength: {
                          value: 6,
                          message: t('minimumLength', { ns: 'backoffice' }),
                        },
                        maxLength: {
                          value: 15,
                          message: t('maximumLength', { ns: 'backoffice' }),
                        },
                      }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          placeholder={t('telefono', { ns: 'backoffice' })}
                        />
                      )}
                    />
                    {errors.phone && <small className="text-danger">{errors.phone.message}</small>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formMail" className="mt-3">
                    <Form.Label className="text-dark label-form">
                      {t('email', { ns: 'contact' })}
                    </Form.Label>
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: { value: true, message: t('fieldrequired', { ns: 'contact' }) },
                        pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: t('emailnotvalid', { ns: 'contact' }) },
                      }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="email"
                          placeholder={t('email', { ns: 'contact' })}
                        />
                      )}
                    />
                    {errors.email && <small className="text-danger">{errors.email.message}</small>}
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="FormDepartment" className="mt-3">
                <Form.Label className="text-dark label-form">
                  {t('status', { ns: 'home' })}
                </Form.Label>
                <Controller
                  name="status"
                  control={control}
                  defaultValue=""
                  rules={{ required: { value: true, message: t('fieldrequired', { ns: 'contact' }) } }}
                  render={({ field }) => (
                    <Form.Control {...field} as="select">
                      <option value="">
                        {t('select', { ns: 'contact' })}
                      </option>
                      <option value="pending">
                        {t('pending', { ns: 'home' })}
                      </option>
                      <option value="rejected">
                        {t('rejected', { ns: 'home' })}
                      </option>
                      <option value="accepted">
                        {t('accepted', { ns: 'home' })}
                      </option>
                    </Form.Control>
                  )}
                />
                {errors.status && <small className="text-danger">{errors.status.message}</small>}
              </Form.Group>
              <Form.Group controlId="FormMessage" className="mt-3">
                <Form.Label className="text-dark ">{t('description', { ns: 'home' })}</Form.Label>
                <Controller
                  name="request_description"
                  control={control}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                      as="textarea"
                      rows={2}
                      placeholder={t('description', { ns: 'home' })}
                    />
                  )}
                />
                {errors.request_description && <small className="text-danger">{errors.request_description.message}</small>}
              </Form.Group>

              <Button
                disabled={showCard}
                type="submit"
                className="mx-auto d-block mt-5 btn-sent"
              >
                {t('send', { ns: 'contact' })}
              </Button>
            </Form>
            <div className="d-flex justify-content-center ">
              {requestStatus && (typeof msg === "string" && msg !== '') &&
                <FeedbackStatus
                  feedbackType={requestStatus}
                  isVisible={showCard}
                  msgObject={msg}
                  onClose={handleClose}
                />
              }
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Affiliate;
